
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/signup",
      function () {
        return require("private-next-pages/admin/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/signup"])
      });
    }
  